import { type ReactNode } from "react";
import { Stack, Typography } from "@mui/material";

export type PlaceholderProps = { title: string };

export const Placeholder = ({ title }: PlaceholderProps): ReactNode => (
  <Stack sx={{ display: "flex", textAlign: "center" }}>
    <Typography variant="h3" component="div">
      This is a placeholder page
    </Typography>
    <Typography variant="h6" component="div">
      {title}
    </Typography>
  </Stack>
);
